module.exports = __webpack_public_path__ + "static/media/image-1.1f18fe11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-1.png
// module id = 2197
// module chunks = 0